import React from 'react';
import { Route, Routes, Navigate, BrowserRouter as Router} from 'react-router-dom';
import Homepage from './frontend/components/Homepage';
import Services from './frontend/components/Services';
import Estimate from './frontend/components/Estimate';
import Header from './frontend/components/Header';
import Footer from './frontend/components/Footer';
import ScrollToTop from './frontend/components/ScrollToTop';

import './App.css';


function App() {
  return (
    <Router>
      <ScrollToTop/>
      <Header/>
      {/* <Navigation/> */}
      <Routes>
        <Route exact path= "/" element={<Homepage/>}>Home</Route>
        <Route path= "/Services" element={<Services/>}>Services</Route>
        <Route path= "/Estimate" element={<Estimate/>}>Services</Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer/>
    </Router>
    
  );
}

export default App;
